module.exports = __webpack_public_path__ + "static/media/social-vkontakte.3898b358.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/avatars/social-vkontakte.svg
// module id = 99
// module chunks = 0